// extracted by mini-css-extract-plugin
export default {"badge":"bNNukX","available":"qKhmS5","current":"YmJccs","pending":"qhRvrG"};